import { getOrdinal } from '@paperstac/helpers/lib/numberHelpers';
import Box from '@paperstac/ui/lib/Box';
import Flex from '@paperstac/ui/lib/Flex';
import React from 'react';

const ListingNotes = React.memo(({ notes, ...props }) => (
  <Box {...props}>
    {notes.map((note, i) => (
      <Flex key={note.id} mt={i > 0 ? 2 : 0}>
        <Flex
          sx={{
            bg: note.lienPosition === 1 ? 'gray.4' : 'gray.7',
            color: note.lienPosition === 1 ? 'gray.9' : 'white',
            borderRadius: 'corner',
            fontSize: [1, 1, 1, 2],
            textAlign: 'center',
            width: [36, 36, 36, 40],
            mr: 2,
            alignItems: 'center',
            justifyContent: 'center',
            fontWeight: 'bold',
          }}
        >
          {getOrdinal(note.lienPosition)}
        </Flex>
        <Flex flexDirection={['column', 'row']} alignItems={['normal', 'center']}>
          <Box fontSize={[2, 2, 2, 3]} mr={[0, 2]}>
            {note.streetAddress}
          </Box>
          <Box fontSize={[1, 1, 1, 2]} color="gray.6">
            {note.cityStateZip}
          </Box>
        </Flex>
      </Flex>
    ))}
  </Box>
));

ListingNotes.propTypes = {};

ListingNotes.defaultProps = {};

ListingNotes.displayName = 'ListingNotes';

export default ListingNotes;
